import React from 'react';
import { Grid, Panel } from 'react-bootstrap';
import { Field, reduxForm } from "redux-form";
import { UnstiledDropdownListField, UnstiledMultiSelectField } from '../../common/Inputs';
import { factories, RECEIVING_POINT } from '../../../constants/dcDepartmentTypes';
import { getSettings } from '../../../actions/settings';
import { connect } from 'react-redux';
import { departments as depType, agents as agentType } from '../../../constants/settingTypes';
import { getFormValues } from "redux-form";
import * as orderStates from "../../../constants/orderStates";


let OnReceivingPointFilter = class extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.getSettings(depType);
        this.props.getSettings(agentType);
    }

    render() {
        const departments = this.props.departments.data ? this.props.departments.data.filter(d => d.Type === RECEIVING_POINT) : [];
        const states = this.props.stateSelector ? this.props.stateSelector() : orderStates.states.filter(s => s.Id === orderStates.ON_RECEIVING_POINT || s.Id === orderStates.OFFLOADED_TO_RECEIVING_POINT);

        const renderSelectedDepartment = ({ item }) => {
            return commonSelectedValueRender(item, departments, 'FullName');
        };
        const commonSelectedValueRender = (item, collection, valueField) => {
            const id = item && item.Id != null ? item.Id : item == '' ? undefined : item;
            const valueFromCollection = collection.find(d => d.Id == id);
            const value = valueFromCollection ? valueFromCollection[valueField] : undefined;
            return (<span>{value}</span>);
        }

        return (
            <Grid fluid={true} >
                <Panel>
                    <Panel.Heading>Фильтр</Panel.Heading>
                    <Panel.Body>
                        <form className='form-horizontal'>
                            <div className="row" style={{ paddingBottom: "10px", paddingRight: "15px", paddingLeft: "15px" }}>
                                <div className='col-md-3'>
                                    <Field name="states" component={UnstiledMultiSelectField} data={states}
                                        valueField='Id'
                                        textField='Name'
                                        label='Статус' />
                                </div>
                                <div className="col-md-3">
                                    <Field name='department' component={UnstiledDropdownListField} data={departments}
                                        valueField='Id'
                                        textField='FullName'
                                        label='Название точки приема'
                                        valueComponent={renderSelectedDepartment} />
                                </div>
                            </div>
                        </form>
                    </Panel.Body>
                </Panel>
            </Grid>)
    }
}

function mapToProps(state, filterName) {
    const departments = state.application.get('settings')[depType];
    const values = getFormValues(filterName)(state);

    return { departments, values };
}

OnReceivingPointFilter = reduxForm({
    form: 'onReceivingPoint'
})(
    connect((state, props) => mapToProps(state, props), { getSettings })(OnReceivingPointFilter)
);

export default OnReceivingPointFilter;


// WEBPACK FOOTER //
// ./src/components/orders/filters/OnReceivingPointFilter.jsx